import crypto from "crypto";

const genarateHash = () => {
  return crypto.randomBytes(6).toString("hex");
};

export default genarateHash;
